<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Monitoramento de Atividade</v-toolbar-title>
                <v-spacer/>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroMonitoramentoAtividade" ref="formCadastroMonitoramentoAtividade" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                <template v-slot:activator="{on}">
                                    <v-text-field type="date" v-model="item.data" label="Data" :rules="fieldRules" dense outlined>
                                        <template v-slot:prepend>
                                            <v-icon v-on="on">mdi-calendar</v-icon>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker locale="pt-br" v-model="item.data" no-title/>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="10">
                          <v-autocomplete v-model="item.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="searchProjeto" hide-no-data hide-selected clearable
                              item-text="codigoNome" item-value="id" label="Projeto" :placeholder="item.projeto ? item.projeto.codigoNome : 'Digite um projeto'" @change="CarregarItens()" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-text-field v-model="item.avaliacao" label="Avaliação" :rules="fieldRules" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                    </v-row>

                    <v-data-table :headers="headers" :items="item.itens" :items-per-page="-1" :hide-default-footer="true" class="elevation-1">

                        <template v-slot:[`item.atividadeItem.dataInicio`]="{ item }">
                            {{ new Date(item.atividadeItem.dataInicio).ddmmyyyy() }}
                        </template>

                        <template v-slot:[`item.atividadeItem.dataTermino`]="{ item }">
                            {{ item.atividadeItem.dataTermino ? new Date(item.atividadeItem.dataTermino).ddmmyyyy() : '' }}
                        </template>

                        <template v-slot:[`item.resultado`]="{ item }">
                            <div>
                                <v-textarea style="margin-bottom: -25px" v-model="item.resultado" maxlength="200" dense outlined height="60px"/>
                            </div>
                        </template>

                        <template v-slot:[`item.documento`]="{ item }">
                            <div style="width: 150px">
                                <v-chip v-if="item.documento" close @click:close="Excluir(item)" color="primary" small><v-icon @click="Download(item)" class="mr-4">mdi-download</v-icon><span class="text-truncate">{{ item.documento }}</span></v-chip>
                                <v-file-input v-else accept=".pdf" v-model="item.salvarArquivo"/>
                            </div>
                        </template>

                        <template v-slot:[`item.status`]="{ item }">
                            <div>
                                <v-select v-model="item.status" :items="status" item-value="key" item-text="value" />
                            </div>
                        </template>

                    </v-data-table>

                </v-form>
            </v-card-text>
        </v-card>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MonitoramentoAtividadeService, StatusAtividadeEnumService } from '@/core/services/projetos/monitoramento/';
import { MonitoramentoAtividade, MonitoramentoAtividadeItem } from '@/core/domain/projetos/monitoramento/';
import ProjetoService from '@/core/services/projetos/ProjetoService';
import jiff from 'jiff';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroMonitoramentoAtividade' in this.$refs)
                this.$refs.formCadastroMonitoramentoAtividade.resetValidation();

        },
        value: function() {
            this.dialog = this.value;
        },
        dialog: function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
            if(this.dialog){
                this.itemOriginal = jiff.clone(this.item);
            }
        },
        searchProjeto (val) {
            if (this.item.projetoId) return;
            if (this.isProjetoLoading) return;
            if (!val) return;
            
            this.isProjetoLoading = true
            const projetoService = new ProjetoService();
            projetoService.AutoComplete(val)
                .then(
                    res => {
                        this.projetos = res.data;
                    },
                    err => this.$swal('Aviso', err.response.data, 'error')
                )
                .finally(() => (this.isProjetoLoading = false))
        }
    },
    data: () => ({
        itemOriginal: null,
        service: new MonitoramentoAtividadeService(),
        valid: true,
        dialog: false,
        isLoading: false,
        isProjetoLoading: false,
        searchProjeto: null,
        projetos: [],
        status: [],
        headers: [
            { text: '', sortable: false  },
            { text: 'Atividade', value:'atividade.nome', align:'left' },
            { text: 'Atividade Item', value:'atividadeItem.nome' },
            { text: 'Início', value:'atividadeItem.dataInicio' },
            { text: 'Término', value:'atividadeItem.dataTermino' },
            { text: 'Resultados', value:'resultado' },
            { text: 'Documento', value:'documento' },
            { text: 'Status', value:'status' }
        ],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        salvando: false
    }),
    methods: {
        CarregarItens(){
            let projeto = this.projetos.find(x => x.id == this.item.projetoId);
            this.item.itens = [];

            projeto.atividades.forEach(x => {
                x.itens.forEach(y => {
                    let atividadeItem = new MonitoramentoAtividadeItem();
                    atividadeItem.atividade = projeto.atividades.find(x => x.id == y.atividadeId);
                    atividadeItem.empresaId = this.sessionApp.empresaId;
                    atividadeItem.monitoramentoAtividadeId = this.item.id;
                    atividadeItem.projetoId = y.projetoId;
                    atividadeItem.atividadeId = y.atividadeId;
                    atividadeItem.atividadeItemId = y.id;
                    atividadeItem.atividadeItem = y;
                    this.item.itens.push(atividadeItem);
                });
            });
        },
        save() {

            if (this.$refs.formCadastroMonitoramentoAtividade.validate()) {

                this.salvando = true;
                
                if(this.item.id > 0){

                    let patchModel = jiff.diff(this.itemOriginal, this.item, false);

                    let teste = []

                    this.item.itens.forEach(x => {
                        if(x.salvarArquivo){
                            teste.push(x)
                        }
                    })

                    this.service.SalvarPatch(patchModel,this.itemOriginal.id).then(
                        res => {
                            if(teste.length > 0){
                                teste.forEach(y => {
                                    this.EnviarDocumento(y.monitoramentoAtividadeId,y.id,y.salvarArquivo).then(
                                        res =>{
                                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                            this.$emit('salvou');
                                            this.close();
                                        },
                                        err =>  {
                                            if (err.response.status == 400) {
                                                this.$swal('Aviso', err.response.data.title, 'warning')    
                                            }
                                            else {
                                                this.$swal('Aviso', err.response.data, 'error')
                                            }
                                        }
                                    )
                                });
                            }
                            else{
                                this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                this.$emit('salvou');
                                this.close();
                            }
                        },
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title, 'warning')    
                            }
                            else {
                                this.$swal('Aviso', err.response.data, 'error')
                            }
                        }
                    ).finally(() => {
                        this.salvando = false;
                    })
                }
                else{
                    let modelo = new MonitoramentoAtividade(this.item);

                    this.item.itens.forEach(x => {
                        x.id = this.item.itens.indexOf(x) + 1;
                    });

                    this.service.Salvar(modelo).then(
                        res => {                            
                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.$emit('salvou');
                            this.close();                     
                        }, 
                        err =>  {
                            if (err.response.status == 400) {
                                this.$swal('Aviso', err.response.data.title, 'warning')    
                            }
                            else {
                                this.$swal('Aviso', err.response.data, 'error')
                            }
                        }
                    ).finally(() => {
                        this.salvando = false;
                    })
                }
            }
        },
        Download(item){
            this.service.DownloadDocumento(item.monitoramentoAtividadeId, item.documento);
        },
        Excluir(item){

            this.service.DeletarDocumento(item.monitoramentoAtividadeId, item.atividadeItemId ,item.documento).then(
                res =>{
                    this.item.itens.find(x => x == item).documento = "";
                }, 
                err =>  {
                    if (err.response.status == 400) {
                        this.$swal('Aviso', err.response.data.title, 'warning')    
                    }
                    else {
                        this.$swal('Aviso', err.response.data, 'error')
                    }
                }
            )
        },
        async EnviarDocumento(monitoramentoAtividadeId, monitoramentoAtividadeItemId, arquivoEnviar){
        
            return new Promise(async (resolve, reject) => {

                let arquivo = await this.Ler(arquivoEnviar);

                this.service.EnviarDocumento(monitoramentoAtividadeId, monitoramentoAtividadeItemId, arquivoEnviar.name, arquivo).then(
                    res => resolve(res),
                    err => reject(err)
                )

            });
        },
        async Ler(arquivo) {
            return new Promise((resolve, reject) => {
            let fr = new FileReader();
        
            fr.onload = (arquivo) => {
                resolve(arquivo.target.result);
            };
        
            fr.readAsArrayBuffer(arquivo);
            });
        },
        close() {
            this.dialog = false;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {
        this.sessionApp = JSON.parse(localStorage.sessionApp);
        let statusAtividadeEnumService = new StatusAtividadeEnumService();
        statusAtividadeEnumService.Listar()
            .then(
                res => {
                    this.status = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

    }
}
</script>